/* eslint-disable no-unused-vars */
import React from "react";

// Navigation Button for Bottom Nav
export function NavButton({ icon: Icon, label, active, onClick }) {
  return (
    <button
      onClick={onClick}
      className={`flex flex-col items-center gap-1 px-4 py-2 rounded-xl transition ${
        active ? "text-pink-500 bg-pink-50" : "text-slate-400 hover:text-slate-600"
      }`}
    >
      <Icon className="w-5 h-5" />
      <span className="text-xs font-medium">{label}</span>
    </button>
  );
}

// Quest Card Component
export function QuestCard({ icon: Icon, title, subtitle, completed, onToggle, color }) {
  const colors = {
    orange: "bg-orange-100 text-orange-500",
    green: "bg-green-100 text-green-500",
    blue: "bg-blue-100 text-blue-500",
    purple: "bg-purple-100 text-purple-500",
    pink: "bg-pink-100 text-pink-500"
  };

  return (
    <div
      onClick={onToggle}
      className={`bg-white rounded-2xl p-4 shadow-sm border transition cursor-pointer ${
        completed ? "border-green-300 bg-green-50" : "border-slate-100 hover:border-slate-200"
      }`}
    >
      <div className="flex items-center gap-3">
        <div className={`w-10 h-10 rounded-full ${colors[color]} flex items-center justify-center ${completed ? "opacity-50" : ""}`}>
          <Icon className="w-5 h-5" />
        </div>
        <div className="flex-1">
          <p className={`font-medium ${completed ? "text-slate-400 line-through" : "text-slate-800"}`}>
            {title}
          </p>
          <p className="text-sm text-slate-500">{subtitle}</p>
        </div>
        <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${
          completed ? "bg-green-500 border-green-500" : "border-slate-200"
        }`}>
          {completed && (
            <svg className="w-4 h-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          )}
        </div>
      </div>
    </div>
  );
}